//Importation des elements nécessaires
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { PageContentDto } from '../../../services/dtos/page-content.dto';
import { Grid } from '@mui/material';

/**
 * Composant de la popup d'informations
 * @param props Le contrat affiché
 * @constructor
 */
export default function DialogCustom(props: { params?: PageContentDto; open: boolean; handleCloseDialog: () => void }) {
    function createMarkup() {
        return { __html: props.params?.content ?? '' };
    }
    //On return le tableau contenant les informations récupérées via API
    return (
        /*Le dialogue comporte un titre et un contenu*/
        <Dialog onClose={props.handleCloseDialog} open={props.open}>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={10}>
                        <Typography variant="h5" sx={{ marginBottom: '5px' }}>
                            {props.params?.title}
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <IconButton
                            aria-label="close"
                            onClick={props.handleCloseDialog}
                            sx={{
                                position: 'absolute',
                                right: 5,
                                top: 5,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            {/*Bouton pour fermer la popup*/}
            <DialogContent dividers>
                <div dangerouslySetInnerHTML={createMarkup()} />
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={props.handleCloseDialog}>
                    Fermer
                </Button>
            </DialogActions>
        </Dialog>
    );
}
